import React, { useState } from 'react'
import { Marker, InfoWindow } from '@react-google-maps/api'
import ConductorImage from '../../../assets/img/splash.png'

const RealTimeDriverMarkers = ({ drivers }) => {
  const [selectedDriver, setSelectedDriver] = useState(null)

  return (
    <>
      {drivers.map((item, index) => {
        const lat = item?.driverData?.l[0] || 0
        const lng = item?.driverData?.l[1] || 0

        return (
          <Marker
            key={index}
            position={{
              lat,
              lng,
            }}
            icon={{
              url: ConductorImage,
              scaledSize: new window.google.maps.Size(40, 40),
            }}
            onClick={() => {
              setSelectedDriver(item)
            }}
          />
        )
      })}

      {selectedDriver && (
        <InfoWindow
          position={{
            lat: selectedDriver.driverData.l[0],
            lng: selectedDriver.driverData.l[1],
          }}
          onCloseClick={() => {
            setSelectedDriver(null)
          }}
        >
          <div>
            <h2>Información del Conductor</h2>
            <p>Nombre: {selectedDriver.driverData.data.nombre || 'N/A'}</p>
            <p>Vehículo: {selectedDriver.driverData.data.vehiculo || 'N/A'}</p>
          </div>
        </InfoWindow>
      )}
    </>
  )
}

export default RealTimeDriverMarkers
